import withLazy from '../../hoc/with-lazy';
const MemberBadgeLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-members-badge" */ './member-badge'),
    errorHandling: { type: 'HANDLE' },
});
export default MemberBadgeLazy;
//# sourceMappingURL=member-badge-lazy.js.map